import moment from "moment";
import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa6";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const Transactions = () => {
  const [loading, setLoading] = useState(true);
  const [allTransactions, setAllTransactions] = useState([]);

  useEffect(() => {
    handleFetchTransactions();
  }, []);

  const handleFetchTransactions = async () => {
    try {
      setLoading(true);
      const response = await getApiCaller("transactions");
      if (response.data.status) {
        setAllTransactions(response.data.response_data);
      }
    } catch (error) {
      toast.error("Failed to fetch images. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-4 md:px-10 mt-4">
      {/* Main container with flex column on mobile, row on desktop */}
      <div className="flex flex-wrap items-center gap-2 text-[13px] sm:text-base lg:text-xl">
        <a href="/profile" className="text-[#284184] hover:underline">
          Profile
        </a>
        <FaChevronRight className="text-[#284184] w-3 h-3 md:w-4 md:h-4" />

        <span className="text-[#284184] font-bold">View Transactions</span>
      </div>

      <div className=" mt-4 bg-white shadow-md rounded-lg">
        <h2 className="text-lg font-semibold text-[#284184] mb-2 p-4">
          Transactions
        </h2>
        {loading ? (
          <div className="flex items-center justify-center h-[59vh]">
            <PropagateLoader color="#284184" loading={true} size={10} />
          </div>
        ) : (
          <div className="divide-y h-[59vh] overflow-auto">
            {allTransactions &&
              allTransactions?.map((transaction) => (
                <div
                  key={transaction.id}
                  className="py-3 flex items-center justify-between"
                >
                  <div className="px-4">
                    <p className="text-gray-800">
                      {transaction.title === "Appointment Schedule Fees"
                        ? transaction?.patient_name
                        : transaction.title}
                    </p>
                    {transaction.title === "Appointment Schedule Fees" && (
                      <p className="text-sm text-gray-500">
                        {transaction.time},{" "}
                        {moment(transaction?.date, "DD-MM-YYYY").format(
                          "DD dddd"
                        )}
                      </p>
                    )}
                  </div>
                  <p
                    className={`text-right font-semibold px-4 ${
                      transaction.is_credit ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {transaction.is_credit ? "+" : "-"}$
                    {Math.abs(transaction.amount)}
                  </p>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Transactions;
